export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.25 6c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 6c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm-2 0c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zm4 6.69a5.996 5.996 0 0111 3.31h-2c0-2.21-1.79-4-4-4s-4 1.79-4 4h-2c0-2.21-1.79-4-4-4s-4 1.79-4 4h-2a5.996 5.996 0 0111-3.31zm5-3.69c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm1-3c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1z\" fill=\"#000\" fill-opacity=\".9\"/>",
  "attrs": {
    "width": "23",
    "height": "18",
    "viewBox": "0 0 23 18",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};